import React from 'react';
import { useRouter } from './Router';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string;
}

export const Link: React.FC<LinkProps> = ({ href, children, ...props }) => {
    const { navigate } = useRouter();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (props.onClick) {
            props.onClick(e);
        }
        // Allow ctrl/meta/shift/middle-click to open in a new tab naturally
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
            return;
        }
        e.preventDefault();
        navigate(href);
    };

    // Expose clean crawlable path in href so Googlebot and search crawlers discover all internal pages
    const cleanHref = href.startsWith('#') || href.startsWith('http') || href.startsWith('/') ? href : `/${href}`;

    return (
        <a href={cleanHref} onClick={handleClick} {...props}>
            {children}
        </a>
    );
};
